// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "95103f27b33211b6","396": "1b07afc02b233ff5","460": "df4470d48cbb9698","917": "92658e0c6c73c433","985": "2e2d85252baa6937",}[chunkId] + ".chunk.js"
}